import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconReports = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath d="M11.4995 9.99931H12.9995" color="none" strokeLinecap="round" strokeLinejoin="round" />
            <StyledPath d="M10.4995 6.99931H12.9995" color="none" strokeLinecap="round" strokeLinejoin="round" />
            <StyledPath d="M9.49951 12.9993H12.9995" color="none" strokeLinecap="round" strokeLinejoin="round" />
            <StyledPath
                d="M2.99951 9.49931C2.99951 10.295 3.31558 11.058 3.87819 11.6206C4.4408 12.1832 5.20386 12.4993 5.99951 12.4993C6.79516 12.4993 7.55822 12.1832 8.12083 11.6206C8.68344 11.058 8.99951 10.295 8.99951 9.49931C8.99951 8.70366 8.68344 7.9406 8.12083 7.37799C7.55822 6.81538 6.79516 6.49931 5.99951 6.49931C5.20386 6.49931 4.4408 6.81538 3.87819 7.37799C3.31558 7.9406 2.99951 8.70366 2.99951 9.49931V9.49931Z"
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <StyledPath
                d="M3.5293 11.1453L5.9993 9.49931V6.49931"
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <StyledPath
                d="M15.2062 3.70598C15.2991 3.79883 15.3729 3.90909 15.4232 4.03046C15.4736 4.15183 15.4995 4.28192 15.4995 4.41331V14C15.4992 14.3975 15.3411 14.7787 15.06 15.0598C14.7789 15.3409 14.3977 15.499 14.0002 15.4993H2.00018C1.8032 15.4994 1.60812 15.4607 1.4261 15.3854C1.24408 15.3101 1.07867 15.1997 0.939323 15.0604C0.799973 14.9212 0.689411 14.7559 0.613948 14.574C0.538485 14.392 0.499599 14.197 0.499512 14V1.99998C0.499424 1.80289 0.53818 1.60771 0.613565 1.4256C0.688949 1.24349 0.799484 1.07802 0.938852 0.938653C1.07822 0.799286 1.24369 0.688751 1.42579 0.613366C1.6079 0.537982 1.80308 0.499226 2.00018 0.499314H11.5848C11.7162 0.499254 11.8463 0.52507 11.9676 0.575286C12.089 0.625502 12.1993 0.699135 12.2922 0.79198L15.2062 3.70598Z"
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <StyledPath
                d="M11.4995 0.499313V3.49931C11.4995 3.76453 11.6049 4.01888 11.7924 4.20642C11.9799 4.39396 12.2343 4.49931 12.4995 4.49931H15.4995"
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
